// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"34dd9bbe","535":"5de6a16e","637":"1ca289f3","971":"032d3c8e"}[chunkId] + ".chunk.js";
};